export default {
  title: "Ҳуҷҷатҳо",
  instruction: "Дастурамал",
};
